$.fn.consultationForm = function () {
    const $form = $(this);
    const $content = $form.find('.js-consult-form-content');
    const $submitBtn = $form.find('button[type="submit"]');
    const $loader = $('<div/>', {
        class: 'loader-container',
        append: $('<div/>', {
            class: 'loader'
        })
    });

    /**
     * Вывод ошибок для полей формы
     * @param {Object} errors - объект с ошибками
     */
    const showErrors = function (errors) {
        $form.find('.form-group').removeClass('has-error');
        Object.keys(errors).forEach(function (name) {
            $form
                .find(`[name="${name}"]`)
                .closest('.form-group')
                .addClass('has-error')
                .find('.help-block')
                .html(errors[name].join('<br>'));
        });
    };

    /**
     * Проверка заполнения необходимых полей
     */
    const isFilled = function () {
        let elements = $form.get(0).elements;
        return elements.phone.value && elements.agree.checked;
    };

    // Включать кнопку отправки только если заполнены необходимые поля
    $form.on('input change', function () {
        $submitBtn.attr('disabled', !isFilled());
    });

    // Обработка отправки формы
    $form.on('submit', function (e) {
        e.preventDefault();

        $content.append($loader);
        $.ajax({
            method: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize()
        }).done(function (response) {
            $loader.remove();
            if (!response.success) {
                showErrors(response.errors);
            } else {
                $content
                    .empty()
                    .append(
                        $('<div/>', {
                            class: 'section-request__title',
                            text: 'Ваша заявка успешно отправлена'
                        })
                    );
            }
        }).fail(function (error) {
            console.log(error);
            $loader.remove();
            $content.find('.error-message').remove();
            $content.append(
                $("<p/>", {
                    class: 'error-message',
                    text: `При отправке заявки произошла ошибка (${error.status}: ${error.statusText})`
                })
            );
        });
    });

    // Начальное состояние кнопки "Отправить"
    $submitBtn.attr("disabled", !isFilled());

    return this;
};

// Инициализация
$('.js-consult-form').each(function () {
    $(this).consultationForm();
});
